import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { mapSetter } from 'commons/vuex/map/map.js';
import { getQueue } from './state.js';
import { clobber } from 'commons/vuex/map/map.js';

export const mutations = {
    [MUTATIONS.SET_QUEUE]: mapSetter(Vue, getQueue),

    [MUTATIONS.ADD_CONTENT_TO_QUEUE](state, { queue_uuid, content_id }) {
        const queue = state[queue_uuid];

        if (!queue.content) {
            queue.content = [];
        }

        if (queue.content.includes(content_id)) {
            return;
        }

        queue.content.push(content_id);
    },

    [MUTATIONS.SET_QUEUE_PROPERTY](state, { key, item }) {
        clobber(state[key], item);
    },

    [MUTATIONS.REMOVE_CONTENT_FROM_QUEUE](state, { content_id, queue_uuid }) {
        const queue = state[queue_uuid];
        queue.content = queue.content.filter((content) => content !== content_id);
    },

    [MUTATIONS.REMOVE_QUEUE](state, queue_uuid) {
        Vue.delete(state, queue_uuid);
    },

    [MUTATIONS.ADD_UNSAVED_CONTENT](state, { queue_uuid, content_id }) {
        if (queue_uuid) {
            state[queue_uuid].unsaved_content = state[queue_uuid].unsaved_content.concat(content_id);
        }
    },

    [MUTATIONS.REMOVE_UNSAVED_CONTENT](state, { queue_uuid, content_id }) {
        if (queue_uuid) {
            state[queue_uuid].unsaved_content = state[queue_uuid].unsaved_content.filter((unsaved_content) => unsaved_content !== content_id);
        }
    },
};
